// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6ea9820","239":"e253d81b","455":"46cb671d"}[chunkId] + ".chunk.js";
};